import { Component, OnInit, Input } from '@angular/core';
import { UserService } from 'src/app/core/services/user.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';

@Component({
  selector: 'app-subordinates-in-bu',
  templateUrl: './subordinates-in-bu.component.html',
  styleUrls: ['./subordinates-in-bu.component.css']
})
export class SubordinatesInBuComponent implements OnInit {

  @Input() userId: any;
  @Input() buId: any;

  users: any[] = [];
  loading = false;

  constructor(private userService: UserService, private alertAndNotificationsService: AlertAndNotificationsService) {
  }

  ngOnInit() {
    this.users = [];
    this.loading = true;
    this.getUsersInBu();
  }

  getUsersInBu() {
    this.loading = true;
    this.userService.getSubordinatesByBu(this.userId, this.buId, (data) => {
      this.users = data;
      this._massageUsersData();
      this.loading = false;
    }, (error) => {
      this.alertAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  private _massageUsersData() {
    this.users.forEach((user) => {
      user.name = user.firstName + ' ' + user.lastName;
    });
  }
}
